/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamAnalysisPatchVideoAnalysisStationSettingsMutationRequest, StreamAnalysisPatchVideoAnalysisStationSettingsMutationResponse, StreamAnalysisPatchVideoAnalysisStationSettingsPathParams, StreamAnalysisPatchVideoAnalysisStationSettings401, StreamAnalysisPatchVideoAnalysisStationSettings403 } from "../models/StreamAnalysisPatchVideoAnalysisStationSettings";

export function getStreamAnalysisPatchVideoAnalysisStationSettingsUrl(entityId: StreamAnalysisPatchVideoAnalysisStationSettingsPathParams["entityId"]) {
  const res = { method: 'PATCH', url: `/stream-analysis/v1/video-analysis/station-settings/${entityId}` as const }
  return res
}

/**
 * @description Only the keys sent in the body are changed; omitted keys keep their current value. Send `null` to clear a setting and fall back to the inherited or default value. Responds with the effective settings after the update. Only settings available to API clients are included.
 * @summary Update settings of a station
 * {@link /stream-analysis/v1/video-analysis/station-settings/:entityId}
 */
export async function streamAnalysisPatchVideoAnalysisStationSettings(entityId: StreamAnalysisPatchVideoAnalysisStationSettingsPathParams["entityId"], data: StreamAnalysisPatchVideoAnalysisStationSettingsMutationRequest, config: Partial<RequestConfig<StreamAnalysisPatchVideoAnalysisStationSettingsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StreamAnalysisPatchVideoAnalysisStationSettingsMutationResponse, ResponseErrorConfig<StreamAnalysisPatchVideoAnalysisStationSettings401 | StreamAnalysisPatchVideoAnalysisStationSettings403>, StreamAnalysisPatchVideoAnalysisStationSettingsMutationRequest>({ method : "PATCH", url : getStreamAnalysisPatchVideoAnalysisStationSettingsUrl(entityId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}